module.exports = __webpack_public_path__ + "assets/img/block-left-f60cb108.png";